import React, {Component} from 'react';
//import InputField from '../../components/new-ui/input_field';
import {injectIntl} from 'react-intl';
import GenericModal from '../../containers/modal/generic_modal';
import {BUTTON_COLOR} from '../../constants';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import UpdateTaskMutation from '../../mutations/update_task_mutation.modern';
import Util from '../../forecast-app/shared/util/util';
import {ESTIMATION_UNIT} from '../../constants';
import 'whatwg-fetch'; //IE 11 fetch polyfill
import HoursInput from '../../forecast-app/shared/components/inputs/hours-input/hours_input_view';
import {AffixedInputWrapper} from '../../forecast-app/shared/components/inputs/AffixedInputWrapper';

class TaskItem extends Component {
	constructor(props) {
		super(props);
		const {isEstimatedInHours, task} = props;
		const {estimateLow, estimateHigh, estimateForecast} = task;
		this.state = {
			estimateLow: isEstimatedInHours ? estimateLow / 60 : estimateLow,
			estimateHigh: isEstimatedInHours ? estimateHigh / 60 : estimateHigh,
			estimateForecast: isEstimatedInHours ? estimateForecast / 60 : estimateForecast,
		};
	}

	onLowEstimateChange(value) {
		this.setState({estimateLow: value});
	}

	onHighEstimateChange(value) {
		this.setState({estimateHigh: value});
	}

	onEstimateBlur(input, value) {
		let estimateLow;
		let estimateHigh;
		let estimateForecast;

		if (input === 'low') {
			this.setState({estimateLow: value});
			estimateLow = value;
			estimateHigh = this.state.estimateHigh || 0;
		} else if (input === 'high') {
			this.setState({estimateHigh: value});
			estimateLow = this.state.estimateLow || 0;
			estimateHigh = value;
		} else if (input === 'estimate') {
			this.setState({estimateForecast: value});
			estimateForecast = value;
		}

		const {task, isEstimatedInHours, removeLowHigh, onTaskEstimated} = this.props;

		if (removeLowHigh) {
			const estimateRounded = (Math.round(parseFloat(estimateForecast * 100)) / 100) * (isEstimatedInHours ? 60 : 1);
			estimateForecast = estimateRounded;
			estimateLow = estimateRounded;
			estimateHigh = estimateRounded;

			if (estimateForecast === this.props.task.estimateForecast) return;
		} else {
			//Round to nearest 0.05 if hours to make sure it produces integer when multiplied by 60, round to two decimals if points
			estimateLow = isEstimatedInHours ? estimateLow : Math.round(parseFloat(estimateLow * 100)) / 100;
			estimateHigh = isEstimatedInHours ? estimateHigh : Math.round(parseFloat(estimateHigh * 100)) / 100;

			let isWrong = estimateLow > estimateHigh;
			this.setState({
				estimateLow,
				estimateHigh,
				isEstimateInvalid: isWrong,
			});

			if (isWrong) return;
			estimateLow *= isEstimatedInHours ? 60 : 1;
			estimateHigh *= isEstimatedInHours ? 60 : 1;
			//Don't mutate if values did not change

			if (estimateLow === this.props.task.estimateLow && estimateHigh === this.props.task.estimateHigh) return;
		}

		const onSuccess = response => {
			if (response.updateTask) {
				this.setState({estimateForecast: response.updateTask.tasks[0].estimateForecast / (isEstimatedInHours ? 60 : 1)});
				onTaskEstimated();
			}
		};
		Util.CommitMutation(UpdateTaskMutation, {ids: [task.id], estimateLow, estimateHigh, forecast: estimateForecast}, onSuccess);
	}

	render() {
		const {task, isEstimatedInHours, intl, removeLowHigh} = this.props;
		const {formatMessage} = intl;
		const {estimateLow, estimateHigh, estimateForecast, isEstimateInvalid} = this.state;

		return (
			<div className="task-item-container">
				<div className="task-info-container">
					<div className="task-name">{task.name}</div>
					{removeLowHigh ? (
						isEstimatedInHours ? (
							<HoursInput customClassName={'estimate-input'} value={estimateForecast} mutation={value => this.onEstimateBlur('estimate', value)}></HoursInput>
						) : (
							<AffixedInputWrapper customClassName={'estimate-input'} value={estimateForecast} callback={value => this.onEstimateBlur('estimate', value)} affix={formatMessage({id: 'common.points.short'})} />
						)
					) : (
						<>
							<HoursInput
								customClassName={'estimate-input'}
								id={`${task.id}-auto-scheduling-modal-estimate-low`}
								value={estimateLow}
								placeholder={formatMessage({id: 'common.low'})}
								mutation={this.onEstimateBlur.bind(this, 'low')}
								hasError={isEstimateInvalid}
							></HoursInput>
							<HoursInput
								customClassName={'estimate-input'}
								id={`${task.id}-auto-scheduling-modal-estimate-high`}
								value={estimateHigh}
								placeholder={formatMessage({id: 'common.high'})}
								mutation={this.onEstimateBlur.bind(this, 'high')}
								hasError={isEstimateInvalid}
							></HoursInput>
							<div className="forecast-text">{isEstimatedInHours ? Util.convertMinutesToFullHour(estimateForecast * 60, intl, true) : formatMessage({id: 'common.x_points'}, {points: estimateForecast})}</div>
						</>
					)}

					{/* <InputField
						id={`${task.id}-auto-scheduling-modal-estimate-low`}
						hideLabel={true}
						placeholder={'0'}
						suffix={formatMessage({id: isEstimatedInHours ? 'common.hours.short' : 'common.points.short'})}
						type="number"
						value={estimateLow || ''}
						onChange={this.onLowEstimateChange.bind(this)}
						onBlur={this.onEstimateBlur.bind(this)}
						invalidInput={isEstimateInvalid}
					/>
					<InputField
						id={`${task.id}-auto-scheduling-modal-estimate-high`}
						hideLabel={true}
						placeholder={'0'}
						suffix={formatMessage({id: isEstimatedInHours ? 'common.hours.short' : 'common.points.short'})}
						type="number"
						value={estimateHigh || ''}
						onChange={this.onHighEstimateChange.bind(this)}
						onBlur={this.onEstimateBlur.bind(this)}
						invalidInput={isEstimateInvalid}
					/> */}
				</div>
				<div className="border-container" />
				<div className="corner-cover" />
			</div>
		);
	}
}

class FixUnestimatedTasksModal extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const {formatMessage} = this.props.intl;
		const {unestimatedTasks, project, onSuccess, removeLowHigh} = this.props;
		const isEstimatedInHours = project.estimationUnit === ESTIMATION_UNIT.HOURS;
		const content = (
			<div className="auto-scheduling-modal">
				<div className="warning-description">In order to accurately calculate the budget, all tasks must have estimates.</div>
				<div className="table-heading-row"> </div>
				<div className="task-items-container">
					<CustomScrollDiv autoHeight={true} autoHeightMin={1} autoHeightMax={500}>
						{unestimatedTasks.map(task => (
							<TaskItem key={task.id} removeLowHigh={removeLowHigh} isEstimatedInHours={isEstimatedInHours} task={task} intl={this.props.intl} onTaskEstimated={onSuccess} />
						))}
					</CustomScrollDiv>
				</div>
			</div>
		);
		return <GenericModal closeModal={this.props.closeModal} buttons={[{text: formatMessage({id: 'common.filter-close'}), color: BUTTON_COLOR.WHITE}]} content={content} headerText={'Estimate tasks'} />;
	}
}

export default injectIntl(FixUnestimatedTasksModal);
